import React from 'react';
import YoutubeBackground from 'react-youtube-background';
import AudioPlayer from 'react-playlist-player';
import ReactAudioPlayer from 'react-audio-player';
import { FiSun, FiMoon, FiVolumeX, FiVolume2 } from 'react-icons/fi';
import './App.css';
import Noise from './noise.mp3'

export default class App extends React.Component {
  state = {
    currentPlayList: {},
    nightMode: false,
    noise: false,
    start: false,
    initialStart: false,
    removeOverlay: false
  };

  setNight = () => this.setState(prevState => ({
    nightMode: !prevState.nightMode
  }));

  setNoise = () => this.setState(prevState => ({
    noise: !prevState.noise
  }));

  setInitialStart = () => this.setState({
    initialStart: true
  });

  setPlaylist = () => {
    setTimeout(() =>
      this.setState({ removeOverlay: true }), 2000
    );
    setTimeout(() =>
      this.setState({ start: true }), 1000
    );
    this.setState({
      currentPlayList: {
        songs: [
          {
            position: '1',
            songName: 'Prambors 102.2 FM',
            songUrl: 'http://masima.rastream.com/masima-pramborsjakarta'
          },
          {
            position: '2',
            songName: 'Trax 101.4 FM',
            songUrl: 'https://n07.radiojar.com/rrqf78p3bnzuv?rj-ttl=5&rj-tok=AAABcf2zkZoA2EuKFhJshOMAmg'
          },
          {
            position: '3',
            songName: 'Brava 103.8 FM',
            songUrl: 'http://ample-08.radiojar.com/5k7t0rq3bnzuv?rj-ttl=5&rj-tok=AAABcf2fwLwAb3HUxX_kPScToQ'
          },
          {
            position: '4',
            songName: 'Indika 91.6 FM',
            songUrl: 'https://s2.radio.co/sf58a82d7d/listen'
          },
          {
            position: '5',
            songName: 'Cosmopolitan 90.4 FM',
            songUrl: 'https://ample-02.radiojar.com/u7d8heq3bnzuv?rj-ttl=5&rj-tok=AAABcf4JMssA9TFhfw1RzHkG6A'
          },
          {
            position: '6',
            songName: 'Oz 90.8 FM',
            songUrl: 'https://ample-02.radiojar.com/rrqf78p3bnzuv?rj-ttl=5&rj-tok=AAABcf2jxzMAsuTzyBEOnfZTfw'
          },
          {
            position: '7',
            songName: 'iRadio 89.6 FM',
            songUrl: 'https://ample-09.radiojar.com/4ywdgup3bnzuv?rj-ttl=5&rj-tok=AAABcf2kjhMA2njhyOq-X7hgYw'
          },
          {
            position: '8',
            songName: 'Hard Rock 87.6 FM',
            songUrl: 'https://ample-05.radiojar.com/7csmg90fuqruv?rj-ttl=5&rj-tok=AAABcf2kQ5YAdrem_s3ZW8COfQ'
          },
          {
            position: '9',
            songName: 'Junks Radio',
            songUrl: 'http://stream.junksradio.com:8205/stream'
          },
        ]
      }
    })
  };

  render() {
    return (
      <div>
        <div className={`${this.state.start ? 'hide' : 'show'} ${this.state.removeOverlay && 'none'} start-overlay`}>
          <button className={this.state.initialStart ? 'show' : 'hide'} onClick={this.setPlaylist}>
            Mulai radio
          </button>
        </div>
        <YoutubeBackground
          className="background"
          videoId={this.state.nightMode ? '8MqcuBT1vBM' : 'u72Hu29Le5g'}
          onReady={this.setInitialStart}
        >
          <ReactAudioPlayer
            controls="true"
            autoPlay="true"
            loop="true"
            className="noise"
            src={Noise}
            muted={this.state.noise ? false : true}
            volume={this.state.noise ? 1 : 0}
          />
          <div className={`${this.state.start ? 'show' : 'hide'} left container page-title`}>
            <h1>Nyetir virtual di Jakarta sambil denger radio</h1>
          </div>
          <div className={`${this.state.start ? 'show' : 'hide'} right container`}>
            <button onClick={this.setNoise}>
              {this.state.noise ? <FiVolume2 /> : <FiVolumeX />} Suara jalan
            </button>
            <button onClick={this.setNight}>
              {this.state.nightMode ? <FiSun /> : <FiMoon />} {this.state.nightMode ? 'Siang' : 'Malam'} hari
            </button>
            <a href={this.state.nightMode ? 'https://www.youtube.com/watch?v=8MqcuBT1vBM' : 'https://www.youtube.com/watch?v=u72Hu29Le5g'}  target="_blank" rel="noopener noreferrer">Sumber</a>
          </div>
          <div className={`${this.state.start ? 'show' : 'hide'}`}>
            <AudioPlayer currentPlayList={this.state.currentPlayList} />
          </div>
        </YoutubeBackground>
      </div>
    );
  }
};